import React, {useEffect, useState} from "react";
import {trans} from "../../../modulesCompiler";


function CookiesAlert()   {
    const [cookies, setCookies] = useState(true);
    const transTitle = trans("cookies title");
    const transDesc = trans("cookies desc");
    const transPrihvatam = trans("prihvatam");

    const accept = () => {
        localStorage.setItem('cookiesConfirmed', true);
        setCookies(true);
    }

    useEffect(() => {
        const cookies = localStorage.getItem('cookiesConfirmed');
        setCookies(!!cookies);
    }, []);

    return  <div>
        {!cookies &&
        <div className="cookies_alert">
            <div className="container">
                <div className="d-md-flex align-items-center pb-5">
                    <div className="flex-grow-1 mb-2 mb-md-0">
                        <div className="mb-2 font-weight-bold fs-3 oswald">
                            {transTitle}
                        </div>
                        {transDesc}
                    </div>
                    <div>
                        <button onClick={accept} className="btn btn-secondary fw-bold">
                            {transPrihvatam}
                        </button>
                    </div>
                </div>

            </div>
        </div>}
    </div>
}
export default CookiesAlert;